import { Component, Input, OnInit, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { Transaction } from '../../models/transaction';
import { MerchantResponseComponent } from '../../merchant-response/merchant-response.component';
import { GlobalAppData } from '../../models/global-app-data';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MerchantResponseData } from '../../models/merchant-models';
import { fetchNewtrnsctnAtmptPayByBank, getQueryParamByName } from '../../common/utils';
import { LoadingService } from '../../services/loading.service';
import { PBBTransactionResponse } from '../../models/paybybank';
import { TransactionStatus } from '../../models/enums/constants';
import { FormGroup } from '@angular/forms';
import { SharedService } from '../../services/shared.service';
import { v4 as uuidv4 } from 'uuid';
import { PaybybankService } from '../../services/paybybank.service';

@Component({
  selector: 'app-pay-by-bank-stub',
  templateUrl: './pay-by-bank-stub.component.html',
  styleUrls: ['./pay-by-bank-stub.component.css']
})
export class PayByBankStubComponent implements OnInit {
  @Input() payByBankStatus: string = '';
  @Input() orderData?: Transaction;
  @Input() spcOscCode: string = '';
  @Input() showStub: boolean = false;
  @Output() modalClosed = new EventEmitter<void>();
  @ViewChild(MerchantResponseComponent) merchantResponseComponent?: MerchantResponseComponent;
  @Input() billingInformation?: FormGroup;
  @Output() payByBankStatusStub = new EventEmitter<string>();

  paymentStatus: string = '';
  isStubEnabled: boolean = false;
  stubUserChoice: string = '';

  @ViewChild('modalContent') modalContent?: TemplateRef<any>;
  private modalRef: NgbModalRef | null = null;

  constructor(
    public gd: GlobalAppData,
    private modalService: NgbModal,
    private loadingService: LoadingService,
    private sharedService: SharedService,
    private pbbService: PaybybankService
  ) {
    console.log(' ---------   PayByBank stub ---------------');
  }

  ngOnInit(): void {
    this.isStubEnabled = this.gd.isStubEnabled ?? false;
  }

  payByBankTrnsctnDefaultAttempt(response: PBBTransactionResponse): void {
    if (!this.billingInformation) {
      console.warn('payByBankTrnsctnDefaultAttempt: billingInformation is undefined');
      this.handleError();
      return;
    }
    sessionStorage.setItem('page', this.gd.attemptCount?.toString() ?? '0');
    sessionStorage.setItem('gd', Buffer.from(JSON.stringify(this.gd)).toString('base64'));
    sessionStorage.setItem('sessionid', getQueryParamByName('jSession') ?? '');

    this.loadingService.setLoading(false, 'internal');
    this.dismissModal('success');
    if (response.transactionStatus === TransactionStatus.pbbapproved && response.transactionStatusCode === 0) {
      this.paymentStatus = 'paymentSuccess';
      this.loadingService.setLoading(true,'internal')
      this.fetchCaptureOnTransactionAttempt(response);
    } else {
      this.payByBankStatus = response.transactionStatus ?? 'failed';
      this.payByBankStatusStub.emit(this.payByBankStatus);
      this.loadingService.setLoading(true,'internal')
      this.fetchCaptureOnTransactionAttempt(response);
    }
  }

  fetchCaptureOnTransactionAttempt(response: PBBTransactionResponse): void {

    const requestBody = this.getRequestBody(response);

    this.pbbService.capturePayByBankOrder(this.gd.transId, requestBody)
      .then((resp) => {
        if (response.transactionStatus === TransactionStatus.pbbapproved) {
          this.redirectToMerchantSuccessURL();
        }else{
          this.handleError()
        }
      })
      .catch((err) => {
        console.log("error", err);
        this.payByBankStatus = "Server Error";
        this.handleError();
      });
  }

  getRequestBody(resp: any): PBBTransactionResponse | null {
    try {
      if (this.isGeneralError(resp)) {
        const pbbResp: PBBTransactionResponse = {
          transactionStatus: resp.payload?.transactionStatus ?? '',
          transactionStatusCode: resp.code ?? 0,
          referenceTransactionID: resp.payload?.referenceTransactionID ?? '',
          transactionStatusDescription: resp.payload?.transactionStatusDescription ?? '',
          merchantTransactionId: resp.payload?.merchantTransactionId ?? '',
          responseVerbiage: resp.payload?.responseVerbiage ?? '',
          security: undefined,
          errorDetails: [],
          teleCheckDetails: undefined
        };
        return pbbResp;
      }
      return resp as PBBTransactionResponse;
    } catch (e) {
      console.error('Invalid JSON input:', e);
      return null;
    }
  }

  isGeneralError(resp: any): boolean {
    const jsonString = JSON.stringify(resp);
    try {
      const obj = JSON.parse(jsonString);
      const hasCodeKey = Object.prototype.hasOwnProperty.call(obj, 'code');
      if (hasCodeKey) {
        this.loadingService.setLoading(true, 'internal');
        this.handleError();
      }
      return hasCodeKey;
    } catch (e) {
      console.error('Invalid JSON string:', e);
      return false;
    }
  }

  ngAfterViewInit(): void {
    if (this.isStubEnabled && this.modalContent) {
      this.openModal();
    } else {
      console.warn('ngAfterViewInit: Modal not opened. isStubEnabled =', this.isStubEnabled, 'modalContent =', this.modalContent);
    }
  }

  openModal(): void {
    try {
      if (this.modalRef) {
        return;
      }
      if (!this.modalContent) {
        console.error('openModal: modalContent is undefined');
        return;
      }
      this.modalRef = this.modalService.open(this.modalContent, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'md',
        backdrop: 'static',
        windowClass: 'pay-by-bank-modal'
      });
    } catch (error) {
      console.error('openModal: Error opening modal', error);
    }
  }

  dismissModal(reason: string): void {
    try {
      if (this.modalRef) {
        this.modalRef.dismiss(reason);
        this.modalRef = null;
        this.modalClosed.emit();
      } else {
        console.warn('dismissModal: No modal reference to dismiss');
      }
    } catch (error) {
      console.error('dismissModal: Error dismissing modal', error);
    }
  }

  sendTxRejectStatus(): void {
    this.modalClosed.emit();
    this.handlePayByBankDecline(1);
  }

  handlePayByBankDecline(pmtAttemptCount: number): void {
      this.paymentStatus = 'paymentError';
      this.paymentStatus = 'declined';
      //capture
      let stubResponse: PBBTransactionResponse;
      let orderId = this.gd.orderTransaction?.order?.epmsOrderId;
      let transactionId = this.gd.transId;
      stubResponse = {
        transactionStatus: 'ERROR',
        transactionStatusCode: 991006,
        referenceTransactionID: uuidv4(),
        transactionStatusDescription: 'User Cancelled',
        merchantTransactionId: orderId+"-"+transactionId,
        responseVerbiage: 'User Cancelled',
        errorDetails: null,
        security: null,
        teleCheckDetails: null
      };
      this.fetchCaptureOnTransactionAttempt(stubResponse);
  }

  redirectToMerchant(urlVal: string): void {
    sessionStorage.clear();
    const paymentActionData: MerchantResponseData = {
      url: urlVal,
      orderTransaction: this.gd.orderTransaction,
      merchantPaymentReq: {}
    };
    if (this.merchantResponseComponent) {
      this.merchantResponseComponent.sendResponseToMerchant('PAYBYBANK', paymentActionData);
    } else {
      console.error('redirectToMerchant: merchantResponseComponent is undefined');
    }
  }

  redirectToMerchantSuccessURL(): void {
    const merchantSuccessURL = this.gd.orderTransaction?.order?.merchantSuccessURL ?? this.gd.oscConfig?.successUrl ?? '';
    if (!merchantSuccessURL) {
      console.error('redirectToMerchantSuccessURL: No valid success URL found');
      return;
    }
    this.redirectToMerchant(merchantSuccessURL);
  }

  redirectToMerchantRejectURL(): void {
    const merchantRejectURL = this.gd.orderTransaction?.order?.merchantRejectURL ?? this.gd.oscConfig?.rejectUrl ?? '';
    if (!merchantRejectURL) {
      console.error('redirectToMerchantRejectURL: No valid reject URL found');
      return;
    }
    this.redirectToMerchant(merchantRejectURL);
  }

  submitPayByBankStub(): void {
    this.gd.paymentType = 'paybybank';
    this.loadingService.setLoading(true, 'internal');

    if (!this.stubUserChoice) {
      console.warn('submitPayByBankStub: No stub user choice selected');
      this.loadingService.setLoading(false, 'internal');
      return;
    }

    const generateRandom16DigitNumber = (): string => {
      return Math.floor(1000000000000000 + Math.random() * 9000000000000000).toString();
    };

    let stubResponse: PBBTransactionResponse;
    let orderId = this.gd.orderTransaction?.order?.epmsOrderId;
    let transactionId = this.gd.transId;
    switch (this.stubUserChoice.toUpperCase()) {
      case 'APPROVED':
        stubResponse = {
          transactionStatus: TransactionStatus.pbbapproved,
          transactionStatusCode: 0,
          referenceTransactionID: uuidv4(),
          transactionStatusDescription: 'Approved',
          merchantTransactionId: orderId+"-"+transactionId,
          responseVerbiage: 'Approved',
          teleCheckDetails: {
            transactionId: generateRandom16DigitNumber(),
            tckResponseCode: '07',
            approvalCode: '2071',
            achTransactionStatus: '1',
            dateTime: new Date().toISOString()
          },
          errorDetails: [],
          security: null
        };
        break;

      case 'CANCEL':
        stubResponse = {
          transactionStatus: 'ERROR',
          transactionStatusCode: 991006,
          referenceTransactionID: uuidv4(),
          transactionStatusDescription: 'User Cancelled',
          merchantTransactionId: orderId+"-"+transactionId,
          responseVerbiage: 'User Cancelled',
          errorDetails: null,
          security: null,
          teleCheckDetails: null
        };
        break;

      case 'ERROR':
        stubResponse = {
          transactionStatus: 'ERROR',
          transactionStatusCode: 100,
          referenceTransactionID: uuidv4(),
          transactionStatusDescription: 'Input is invalid',
          merchantTransactionId: orderId+"-"+transactionId,
          responseVerbiage: 'Input is invalid',
          errorDetails: [{
            errorCode: 1020,
            errorField: '',
            errorReason: 'The transactions has an invalid or missing value in one or more fields'
          }],
          teleCheckDetails: {
            transactionId: generateRandom16DigitNumber(),
            tckResponseCode: '27',
            approvalCode: null,
            achTransactionStatus: '0',
            dateTime: new Date().toISOString()
          },
          security: null
        };
        break;

      default:
        console.error('submitPayByBankStub: Invalid stub user choice:', this.stubUserChoice);
        this.loadingService.setLoading(false, 'internal');
        return;
    }
    this.processStubResponse(stubResponse);
  }

  processStubResponse(response: PBBTransactionResponse): void {
    this.payByBankTrnsctnDefaultAttempt(response);
  }

  handleError(): void {
    this.payByBankStatus = 'paymentError';
    this.payByBankStatusStub.emit(this.payByBankStatus);
    this.dismissModal('error');
    if (this.billingInformation) {
      this.billingInformation.reset();
    }
    if ((this.gd.attemptCount) < (this.gd.oscConfig?.maxRejectAtmptCount)) {
      fetchNewtrnsctnAtmptPayByBank(this.sharedService, this.gd, this.loadingService);
      this.loadingService.setLoading(false,'internal')
    } else {
      this.redirectToMerchantRejectURL();
    }
  }

  onStubChoiceSelected(choice: string): void {
    this.stubUserChoice = choice;
  }
}